// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2p9hX","vLegacy":"SelectSecondary_vLegacy__7t_1L","error":"SelectSecondary_error__sL8iB","disabled":"SelectSecondary_disabled__3TY77"};